import { createContext, useContext, PropsWithChildren } from 'react';
import useProductPage from './useProductPage';
import { ProductPageProps, useProductPageResult } from './types';

type Ctx = useProductPageResult;

const ProductPageContext = createContext<Ctx | null>(null);

export function useProductPageContext() {
  const ctx = useContext(ProductPageContext);

  if (!ctx) {
    throw new Error('useProductPage must be used within ProductPageProvider');
  }

  return ctx;
}

export function ProductPageProvider({
  props,
  children,
}: PropsWithChildren<{ props: ProductPageProps }>) {
  const value = useProductPage(props);

  return (
    <ProductPageContext.Provider value={value}>
      {children}
    </ProductPageContext.Provider>
  );
}
